import React from 'react'
import Slider from 'react-slick'
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'
import styled from 'styled-components'
import { IoIosArrowBack, IoIosArrowForward } from 'react-icons/io'
import Img from 'gatsby-image'

export default props => {

    const ArrowLeft = props => {
        const { className, style, onClick } = props;

        return (
            <IoIosArrowForward
                className={className}
                role="button"
                aria-labelledby="control-button"
                aria-hidden="true"
                tabIndex="0"
                style={{ ...style }}
                onClick={onClick}
                onKeyDown={onClick}
            />
        )
    }

    const ArrowRight = props => {
        const { className, style, onClick } = props;

        return (
            <IoIosArrowBack
                className={className}
                role="button"
                aria-labelledby="control-button"
                aria-hidden="true"
                tabIndex="0"
                style={{ ...style }}
                onClick={onClick}
                onKeyDown={onClick}
            />
        )
    }
    
    const settings = {
        autoplay: true,
        lazyLoad: true,
        arrows: true,
        center: true,
        speed: 500,
        slidesToShow: typeof props.slidesDesktop !== 'undefined' ? parseInt(props.slidesDesktop) : 1,
        slidesToScroll: 1,
        nextArrow: <ArrowLeft />,
        prevArrow: <ArrowRight />,
        responsive: [
            {
                breakpoint: 900,
                settings: {
                    slidesToShow: typeof props.slidesMobile !== 'undefined' ? parseInt(props.slidesMobile) : 1 
                }
            }
        ]
    }


    const slides = props.content.media

    return (
        <Container>
            <Slider {...settings}>
                {
                    slides.map((slide,index) => 
                        <Wrapper  key={index}>
                            {
                                slide.fluid ?  
                                    <Img fluid={slide.fluid} alt={slide.description} /> 
                                :
                                    slide.file.url ?
                                        <img src={slide.file.url} alt={slide.title}/>
                                    :
                                        '' 
                            }                           
                        </Wrapper>
                    )
                }
            </Slider>
        </Container>
    )
}

const Container = styled.div`
    .slick-prev, .slick-next {
        color: #000!important;
        height: 3rem!important;
        width: 3rem!important;
    }
    .slick-track {
        display: flex;
    }
    .slick-track .slick-slide {
        display: flex;
        height: auto;
        align-items: center;
        justify-content: center;
    }
`
const Wrapper = styled.div`
    display: flex !important;
    flex-direction: column;
    span {
        margin: 1rem auto;
        font-weight: bold;
    }

`